<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="lg:max-w-detail lg:mr-auto">
            <div class="flex items-center"
              v-if="!modeTemplate"
            >
              <input
                class='k-checkbox !mr-2 checkbox-lg'
                type='checkbox'
                v-model="checkall"
                @click="changeAllCheckbox(!checkall)"
              />
              <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">{{$t('app.check_all_fields')}}</label>
            </div>

            <base-collapsible-form 
              v-if="hasModuleCustomLogo"
              ref="baseCollapsibleLogo" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <div class="flex items-center">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.logo_custom')}}</h4>
                  <base-tooltip-icon size="sm" :content="tooltipContentLogo" class="ml-2"/>
                </div>
              </template>
              <template slot="content">
                <div>
                  <div class="flex items-center px-2 w-full mb-2">
                    <input
                      v-if="!modeTemplate"
                      class='k-checkbox !mr-2 checkbox-lg '
                      type='checkbox'
                      v-model="valuesCheckbox.fileLight"
                    />
                    <label class="w-full dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">{{$t('app.mode_light')}}</label>
                  </div>
                  <div class="flex -mx-2 flex-col lg:flex-row">
                    <div class="px-2 mb-2 lg:mb-0">
                      <el-form-item prop="fileLight" ref="uploadlogo">
                        <Upload
                          ref="upload"
                          id="pfxselector"
                          class="bg-white dark:bg-darkblue-900"
                          :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                          drag
                          action="#"
                          accept="image/png,image/webp"
                          :limit=1
                          :multiple="false"
                          :auto-upload=false
                          :on-remove="handleRemoveLight"
                          :on-change="handleChangeLight">
                          <i class="el-icon-upload"></i>
                          <p v-if="fileLight.name" class="el-upload__text"><em>{{fileLight.name}}</em></p>
                          <div v-else class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', 1)"></div>
                        </Upload>
                      </el-form-item>
                      <div class="">
                        <div v-if="fileLight.b64" class="flex flex-col pb-10 ">
                          <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">{{$t('personalization.logo_custom_previsualizacion')}}</label>
                          <div class="flex items-center gap-x-2">
                            <img 
                              id="logo-custom-client-light" 
                              ref="logo-custom-client-light" 
                              :src="'data:image/png;base64, ' + fileLight.b64" 
                              :alt="$t('personalization.logo_custom_light')" 
                              class="w-[300px] h-[74px] border-2 border-solid border-primary-300 dark:bg-white rounded object-scale-down object-left"/>
                            <base-button-icon 
                              v-if="hasLogoLightSaved" 
                              name="cross" 
                              size="xs" 
                              iconSize="xs" 
                              mode="primary-phantom" 
                              @click="handleRemoveLight"/>
                          </div>
                        </div>
                        <div v-else class="flex flex-col pb-10 ">
                          <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">{{$t('personalization.empty_logo_info_msg')}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="flex items-center px-2 w-full mb-2">
                    <input
                      v-if="!modeTemplate"
                      class='k-checkbox !mr-2 checkbox-lg '
                      type='checkbox'
                      v-model="valuesCheckbox.fileDark"
                    />
                    <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">{{$t('app.mode_dark')}}</label>
                  </div>
                  <div class="flex -mx-2 flex-col lg:flex-row">
                    <div class="px-2 mb-2 lg:mb-0">
                      <el-form-item prop="fileDark" ref="uploadlogo">
                        <Upload
                          ref="upload"
                          id="pfxselector"
                          class="bg-white dark:bg-darkblue-900"
                          :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                          drag
                          action="#"
                          accept="image/png,image/webp"
                          :limit=1
                          :multiple="false"
                          :auto-upload=false
                          :on-remove="handleRemoveDark"
                          :on-change="handleChangeDark">
                          <i class="el-icon-upload"></i>
                          <p v-if="fileDark.name" class="el-upload__text"><em>{{fileDark.name}}</em></p>
                          <div v-else class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', 1)"></div>
                        </Upload>
                      </el-form-item>
                      <div class="">
                        <div v-if="fileDark.b64" class="flex flex-col pb-10 ">
                          <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">{{$t('personalization.logo_custom_previsualizacion')}}</label>
                          <div class="flex items-center gap-x-2">
                            <img 
                              id="logo-custom-client-dark" 
                              ref="logo-custom-client-dark" 
                              :src="'data:image/png;base64, ' + fileDark.b64" 
                              :alt="$t('personalization.logo_custom_dark')" 
                              class="w-[300px] h-[74px] border-2 border-solid border-primary-300 bg-darkblue-800 rounded object-scale-down object-left"/>
                            <base-button-icon 
                              v-if="hasLogoDarkSaved" 
                              name="cross" 
                              size="xs"
                              iconSize="xs" 
                              mode="primary-phantom" 
                              @click="handleRemoveDark"/>
                          </div>
                        </div>
                        <div v-else class="flex flex-col pb-10 ">
                          <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">{{$t('personalization.empty_logo_info_msg')}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </base-collapsible-form>

            <base-collapsible-form 
              v-if="hasModuleCustomColors"
              ref="baseCollapsibleColors" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <div class="flex items-center">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.colors_custom')}}</h4>
                  <!-- <base-tooltip-icon size="sm" :content="tooltipContentColors" class="ml-2"/> -->
                </div>
              </template>
              <template slot="content">
                <div class="flex items-center mb-4">
                  
                    <input
                      v-if="!modeTemplate"
                      class='k-checkbox !mr-2 checkbox-lg'
                      type='checkbox'
                      v-model="valuesCheckbox.color"
                    />
                  <label v-if="colorSelected" class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mr-2">{{$t('personalization.colors_custom_selected')}}</label>
                  <label v-else class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mr-2">{{$t('personalization.colors_custom_not_selected')}}</label>
                
                  <el-color-picker
                    v-model="colorSelected"
                    :predefine="predefineColors">
                  </el-color-picker>
                  <p class="hidden">{{colorSelected}}</p>
                </div>
                <p v-if="colorSelected" class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 mb-6">
                  {{$t('personalization.colors_custom_extend')}}
                </p>
              </template>
            </base-collapsible-form>

            <base-collapsible-form 
              v-if="hasModuleCustomSMTPCliente"
              ref="baseCollapsibleCustomMailSmtp" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_smtp')}}</h4>
              </template>
              <template slot="content">

                <div class="mb-4">
                  <div class="flex items-center px-2 w-full mb-1">
                    <input
                      v-if="!modeTemplate"
                      class='k-checkbox !mr-2 checkbox-lg '
                      type='checkbox'
                      v-model="valuesCheckbox.Smtp"
                    />
                    <div class="w-full">
                      <label class="text-sm font-semibold text-secondary-600 block">{{$t('smtp.main')}}</label>
                      <el-switch 
                        class="switch-text break-normal both-switch" 
                        v-model="form.smtpMain" 
                        :active-text="$t('smtp.custom')"
                        :inactive-text="$t('smtp.default')"
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                  </div>
                </div>

                <div v-if="form.smtpMain">
                  <div class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">
                        <base-obligatory-icon/>{{$t('smtp.server')}}
                      </label>
                      <el-form-item prop="smtpServer">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.smtpServer"
                          maxlength='200'
                        />
                      </el-form-item>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">
                        <base-obligatory-icon/>{{$t('smtp.from')}}
                      </label>
                      <el-form-item prop="smtpFrom">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.smtpFrom"
                          maxlength='100'
                        />
                      </el-form-item>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">
                        <base-obligatory-icon/>{{$t('smtp.port')}}
                      </label>
                      <el-form-item prop="smtpPort">
                        <el-input
                          clearable
                          class="w-full"
                          v-model.number="form.smtpPort"
                          maxlength='10'
                        />
                      </el-form-item>
                    </div>
                  </div>

                  <div class="mb-4">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('smtp.ssl')}}</label>
                    <el-switch 
                      class="switch-text break-normal both-switch" 
                      v-model="form.smptSSL" 
                      :active-text="$t('app.active')"/>
                  </div>

                  <div class="mb-4">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('smtp.oauth2')}}</label>
                    <el-switch 
                      class="switch-text break-normal both-switch" 
                      v-model="form.smptOAuth2" 
                      :active-text="$t('app.active')"/>
                  </div>

                  <div class="lg:mb-2" v-if="form.smptOAuth2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">
                        <base-obligatory-icon/>{{$t('smtp.clientid')}}
                      </label>
                      <el-form-item prop="smptClientId">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.smptClientId"
                          maxlength='100'
                        />
                      </el-form-item>
                    </div>
                  </div>

                  <div class="lg:mb-2" v-if="form.smptOAuth2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">
                        <base-obligatory-icon/>{{$t('smtp.tenantid')}}
                      </label>
                      <el-form-item prop="smptTenantId">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.smptTenantId"
                          maxlength='100'
                        />
                      </el-form-item>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">
                        <base-obligatory-icon/>{{$t('smtp.user')}}
                      </label>
                      <el-form-item prop="smtpUser">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.smtpUser"
                          maxlength='100'
                        />
                      </el-form-item>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">
                        <base-obligatory-icon/>{{$t('smtp.pass')}}
                      </label>
                      <el-form-item prop="smtpPass">
                        <el-input
                          :disabled="disableEditPass"
                          clearable
                          show-password
                          class="w-full"
                          v-model="form.smtpPass"
                          autocomplete="new-password"
                          maxlength='100'
                        >
                          <base-button-icon
                            v-if="visibleEditPass && modeTemplate"
                            slot="append" 
                            @click="editSmtpPassToggle()"
                            :name="disableEditPass ? 'editpencil' : 'cross'"
                            iconSize="md"
                            size="xs"
                            mode="primary-phantom"
                            class="bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full"
                          />
                        </el-input>
                      </el-form-item>
                    </div>
                  </div>

                  <!-- <div class="mb-4">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('smtp.confirmacion_entrega')}}</label>
                    <el-switch 
                      class="switch-text break-normal both-switch" 
                      v-model="form.smptConfirmacionEntrega" 
                      :active-text="$t('app.active')"/>
                  </div> -->
                </div>

              </template>
            </base-collapsible-form>

            <div v-if="hasModuleCustomMails">

              <base-collapsible-form 
                ref="baseCollapsibleCustomMailNuevoUsuario" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_nuevo_usuario')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailNuevoUsuario"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_asunto')}}</label>
                        <el-form-item prop="asuntoMailNuevoUsuario">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.asuntoMailNuevoUsuario"
                            maxlength='255'
                          />
                        </el-form-item>
                    </div>
                  </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultNuevoUsuario"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_cuerpo')}}</label>
                    </div>
                  </div>

                  <TextEditor
                    ref="textEditorCustomMailNuevoUsuario"
                    :contentDefault="contentTextEditorDefaultNuevoUsuario"
                    idDefault="customMailNuevoUsuario"
                    class="mb-4"
                    :tags="tagsCustomMailNuevoUsuario"
                    />
                  </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                ref="baseCollapsibleCustomMailDobleAuth" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_doble_auth')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailDobleAuth"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_asunto')}}</label>
                        <el-form-item prop="asuntoMailDobleAuth">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.asuntoMailDobleAuth"
                            maxlength='255'
                          />
                        </el-form-item>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultDobleAuth"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_cuerpo')}}</label>
                      </div>
                    </div>

                    <TextEditor
                      ref="textEditorCustomMailDobleAuth"
                      :contentDefault="contentTextEditorDefaultDobleAuth"
                      idDefault="customMailDobleAuth"
                      class="mb-4"
                      :tags="tagsCustomMailDobleAuth"
                    />
                  </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                ref="baseCollapsibleCustomMailEnviosMasivos" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_envios_masivos')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailEnviosMasivos"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_asunto')}}</label>
                        <el-form-item prop="asuntoMailEnviosMasivos">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.asuntoMailEnviosMasivos"
                            maxlength='255'
                          />
                        </el-form-item>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultEnviosMasivos"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_cuerpo')}}</label>
                      </div>
                    </div>

                    <TextEditor
                      ref="textEditorCustomMailEnviosMasivos"
                      :contentDefault="contentTextEditorDefaultEnviosMasivos"
                      idDefault="customMailEnviosMasivos"
                      class="mb-4"
                      :tags="tagsCustomMailEnviosMasivos"
                    />
                  </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                ref="baseCollapsibleCustomMailEnviarFactura" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_enviar_factura')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailEnviarFactura"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_asunto')}}</label>
                        <el-form-item prop="asuntoMailEnviarFactura">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.asuntoMailEnviarFactura"
                            maxlength='255'
                          />
                        </el-form-item>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultEnviarFactura"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_cuerpo')}}</label>
                      </div>
                    </div>

                    <TextEditor
                      ref="textEditorCustomMailEnviarFactura"
                      :contentDefault="contentTextEditorDefaultEnviarFactura"
                      idDefault="customMailEnviarFactura"
                      class="mb-4"
                      :tags="tagsCustomMailEnviarFactura"
                    />
                  </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                ref="baseCollapsibleCustomMailRecuperacionPass" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_recuperacion_pass')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailRecuperacionPass"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_asunto')}}</label>
                        <el-form-item prop="asuntoMailRecuperacionPass">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.asuntoMailRecuperacionPass"
                            maxlength='255'
                          />
                        </el-form-item>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultRecuperacionPass"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_cuerpo')}}</label>
                      </div>
                    </div>

                    <TextEditor
                      ref="textEditorCustomMailRecuperacionPass"
                      :contentDefault="contentTextEditorDefaultRecuperacionPass"
                      idDefault="customMailRecuperacionPass"
                      class="mb-4"
                      :tags="tagsCustomMailRecuperacionPass"
                    />
                  </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                ref="baseCollapsibleCustomMailOtrosAvisos" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_otros_avisos')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailOtrosAvisos"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_asunto')}}</label>
                        <el-form-item prop="asuntoMailOtrosAvisos">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.asuntoMailOtrosAvisos"
                            maxlength='255'
                          />
                        </el-form-item>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultOtrosAvisos"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_cuerpo')}}</label>
                      </div>
                    </div>

                    <TextEditor
                      ref="textEditorCustomMailOtrosAvisos"
                      :contentDefault="contentTextEditorDefaultOtrosAvisos"
                      idDefault="customMailOtrosAvisos"
                      class="mb-4"
                      :tags="tagsCustomMailOtrosAvisos"
                    />
                  </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                ref="baseCollapsibleCustomMailNuevaFacturaEmitida" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_nueva_factura_emitida')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailNuevaFacturaEmitida"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_asunto')}}</label>
                        <el-form-item prop="asuntoMailNuevaFacturaEmitida">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.asuntoMailNuevaFacturaEmitida"
                            maxlength='255'
                          />
                        </el-form-item>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultNuevaFacturaEmitida"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_cuerpo')}}</label>
                      </div>
                    </div>

                    <TextEditor
                      ref="textEditorCustomMailNuevaFacturaEmitida"
                      :contentDefault="contentTextEditorDefaultNuevaFacturaEmitida"
                      idDefault="customMailNuevaFacturaEmitida"
                      class="mb-4"
                      :tags="tagsCustomMailNuevaFacturaEmitida"
                    />
                  </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                ref="baseCollapsibleCustomMailNuevaFacturaRecibida" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_nueva_factura_recibida')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailNuevaFacturaRecibida"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_asunto')}}</label>
                        <el-form-item prop="asuntoMailNuevaFacturaRecibida">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.asuntoMailNuevaFacturaRecibida"
                            maxlength='255'
                          />
                        </el-form-item>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultNuevaFacturaRecibida"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_cuerpo')}}</label>
                      </div>
                    </div>

                    <TextEditor
                      ref="textEditorCustomMailNuevaFacturaRecibida"
                      :contentDefault="contentTextEditorDefaultNuevaFacturaRecibida"
                      idDefault="customMailNuevaFacturaRecibida"
                      class="mb-4"
                      :tags="tagsCustomMailNuevaFacturaRecibida"
                    />
                  </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                ref="baseCollapsibleCustomMailCambioEstadoFactura" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_cambio_estado_factura')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailCambioEstadoFactura"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_asunto')}}</label>
                        <el-form-item prop="asuntoMailCambioEstadoFactura">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.asuntoMailCambioEstadoFactura"
                            maxlength='255'
                          />
                        </el-form-item>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultCambioEstadoFactura"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_cuerpo')}}</label>
                      </div>
                    </div>

                    <TextEditor
                      ref="textEditorCustomMailCambioEstadoFactura"
                      :contentDefault="contentTextEditorDefaultCambioEstadoFactura"
                      idDefault="customMailCambioEstadoFactura"
                      class="mb-4"
                      :tags="tagsCustomMailCambioEstadoFactura"
                    />
                  </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                ref="baseCollapsibleCustomMailFacturaVinculada" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_factura_vinculada')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailFacturaVinculada"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_asunto')}}</label>
                        <el-form-item prop="asuntoMailFacturaVinculada">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.asuntoMailFacturaVinculada"
                            maxlength='255'
                          />
                        </el-form-item>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultFacturaVinculada"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_cuerpo')}}</label>
                      </div>
                    </div>

                    <TextEditor
                      ref="textEditorCustomMailFacturaVinculada"
                      :contentDefault="contentTextEditorDefaultFacturaVinculada"
                      idDefault="customMailFacturaVinculada"
                      class="mb-4"
                      :tags="tagsCustomMailFacturaVinculada"
                    />
                  </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                ref="baseCollapsibleCustomMailAvisoAutofactura" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_aviso_auto_factura')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailAvisoAutofactura"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_asunto')}}</label>
                        <el-form-item prop="asuntoMailAvisoAutofactura">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.asuntoMailAvisoAutofactura"
                            maxlength='255'
                          />
                        </el-form-item>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultAvisoAutofactura"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_cuerpo')}}</label>
                      </div>
                    </div>

                    <TextEditor
                      ref="textEditorCustomMailAvisoAutofactura"
                      :contentDefault="contentTextEditorDefaultAvisoAutofactura"
                      idDefault="customMailAvisoAutofactura"
                      class="mb-4"
                      :tags="tagsCustomMailAvisoAutofactura"
                    />
                  </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                ref="baseCollapsibleCustomMailEnviarAutofactura" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_enviar_auto_factura')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailEnviarAutofactura"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_asunto')}}</label>
                        <el-form-item prop="asuntoMailEnviarAutofactura">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.asuntoMailEnviarAutofactura"
                            maxlength='255'
                          />
                        </el-form-item>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="!modeTemplate"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultEnviarAutofactura"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_cuerpo')}}</label>
                      </div>
                    </div>

                    <TextEditor
                      ref="textEditorCustomMailEnviarAutofactura"
                      :contentDefault="contentTextEditorDefaultEnviarAutofactura"
                      idDefault="customMailEnviarAutofactura"
                      class="mb-4"
                      :tags="tagsCustomMailEnviarAutofactura"
                    />
                  </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                v-if="form.asuntoMailFinWizard"
                ref="baseCollapsibleCustomMailFinWizard" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('personalization.custom_mail_fin_wizard')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="false"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.asuntoMailFinWizard"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_asunto')}}</label>
                        <el-form-item prop="asuntoMailFinWizard">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.asuntoMailFinWizard"
                            maxlength='255'
                          />
                        </el-form-item>
                      </div>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    
                    <div class="flex items-center px-2 w-full mb-1">
                      <input
                        v-if="false"
                        class='k-checkbox !mr-2 checkbox-lg '
                        type='checkbox'
                        v-model="valuesCheckbox.contentTextEditorDefaultFinWizard"
                      />
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('personalization.mail_cuerpo')}}</label>
                      </div>
                    </div>

                    <TextEditor
                      ref="textEditorCustomMailFinWizard"
                      :contentDefault="contentTextEditorDefaultFinWizard"
                      idDefault="customMailFinWizard"
                      class="mb-4"
                      :tags="tagsCustomMailFinWizard"
                    />
                  </div>
                </template>
              </base-collapsible-form>

            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isFromClient ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="enableEditCampos" mode="primary" :forceIcon="true" :text="!modeTemplate ? $t('configurations.change_mode_template') : $t('app.edit_fields')" @click="toggleModeTemplate()"  icon="refresh" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('configurations.link_template_to_entity', { entity })" @click="toggleDialogLink"  icon="link" :loading="isGeneralLoading"/>
          <base-button-responsive 
            v-if="!modeTemplate" 
            mode="primary" 
            :text="$t('configurations.apply_to_entity', { entity })" 
            @click="toggleDialogLink"  
            icon="link" 
            :loading="isGeneralLoading"
            v-popover:popover
          />
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <el-popover
            ref="popover"
            placement="top"
            width="250"
            v-model="showPopoverRedirection"
            popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
            trigger="manual"
          >
            <div v-html="$t('app.preselected_entities', { entity })" />
          </el-popover>
        </template>
      </base-footer>
      <template-link-clients-dialog 
        ref="templatelinkcompaniesdialog" 
        :title="titleLinkClients" 
        :distributorId="this.id" 
        :dialogOpen="linkToClientsDialog" 
        @toggleDialog="toggleDialogLink" 
        @applyDialog="applyLinkHandler" />
    </template>
  </detail-layout-full-width>
</template>

<script>
import { bus } from '@/main'
import { getLogoCustomTemplate } from '@/services/clients/getLogoCustomTemplate'
import { getConfigSMTPTemplate } from '@/services/clients/getConfigSMTPTemplate'
import { getConfigCorreosTemplate } from '@/services/clients/getConfigCorreosTemplate'
import { getConfigCorreosTags } from '@/services/clients/getConfigCorreosTags'
import { getColorsCustomTemplate } from '@/services/clients/getColorsCustomTemplate'

import { updateClientPersonalizacionTemplate } from '@/services/clients/updateClientPersonalizacionTemplate'
import { applyClientPersonalizationTemplate } from '@/services/clients/applyClientPersonalizationTemplate'
import { applyClientPersonalizationKeys } from '@/services/clients/applyClientPersonalizationKeys'
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import TemplateLinkClientsDialog from '@/components/TemplateLinkClientsDialog.vue'

import { i18n } from '@/i18n'
import { COLORES_PREDEFINIDOS } from '@/config/colores-predefinidos'

import { Upload } from 'element-ui'
import TextEditor from '@/components/texteditor/TextEditor.vue'
import { getDistributor } from '@/services/distributors/getDistributor'

function isValidNum (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 999999) {
      return true
    }
  }
  return false
}
export default {
  /* eslint-disable camelcase */
  name: 'template-client-personalization-detail',
  components: {
    DetailLayoutFullWidth,
    TemplateLinkClientsDialog,
    Upload,
    TextEditor,
  },
  data: function () {
    return {
      isMounted: false,
      modeTemplate: true,
      showPopoverRedirection: false,
      enableEditCampos: true,
      searchView: false,
      linkToClientsDialog: false,
      activeName: 'es',
      entity: i18n.t('clients.header').toLowerCase(),
      tooltipContentLogo: i18n.t('tooltip.logo'),
      header: {
        title: i18n.t('distributors.template_clients_personalization_header'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromClient ? 'configurations/distributors/details' : 'configurations/clients'
      },

      colorSelected: null,
      predefineColors: COLORES_PREDEFINIDOS,

      visibleEditPass: true,
      disableEditPass: true,
        
      form: {
        idClient: null,
        smtpMain: false,
        smtpServer: null,
        smtpFrom: null,
        smtpPort: null,
        smptSSL: true,
        smptOAuth2: null,
        smptClientId: null,
        smptTenantId: null,
        smtpUser: null,
        smtpPass: null,
        // smptConfirmacionEntrega: false,
        asuntoMailNuevoUsuario: '',
        asuntoMailRecuperacionPass: '',
        asuntoMailDobleAuth: '',
        asuntoMailEnviosMasivos: '',
        asuntoMailEnviarFactura: '',
        asuntoMailOtrosAvisos: '',
        asuntoMailNuevaFacturaEmitida: '',
        asuntoMailNuevaFacturaRecibida: '',
        asuntoMailCambioEstadoFactura: '',
        asuntoMailFacturaVinculada: '',
        asuntoMailAvisoAutofactura: '',
        asuntoMailEnviarAutofactura: '',
        asuntoMailFinWizard: '',
      },
      // Contenido para cada TextEditor
      contentTextEditorDefaultOtrosAvisos: '',
      contentTextEditorDefaultNuevaFacturaEmitida: '',
      contentTextEditorDefaultNuevaFacturaRecibida: '',
      contentTextEditorDefaultCambioEstadoFactura: '',
      contentTextEditorDefaultFacturaVinculada: '',
      contentTextEditorDefaultAvisoAutofactura: '',
      contentTextEditorDefaultEnviarAutofactura: '',
      contentTextEditorDefaultNuevoUsuario: '',
      contentTextEditorDefaultRecuperacionPass: '',
      contentTextEditorDefaultDobleAuth: '',
      contentTextEditorDefaultEnviosMasivos: '',
      contentTextEditorDefaultEnviarFactura: '',
      contentTextEditorDefaultFinWizard: '',
      
      // Etiquetas para cada TextEditor
      tagsCustomMailNuevoUsuario: [],
      tagsCustomMailRecuperacionPass: [],
      tagsCustomMailDobleAuth: [],
      tagsCustomMailEnviosMasivos: [],
      tagsCustomMailEnviarFactura: [],
      tagsCustomMailOtrosAvisos: [],
      tagsCustomMailNuevaFacturaEmitida: [],
      tagsCustomMailNuevaFacturaRecibida: [],
      tagsCustomMailCambioEstadoFactura: [],
      tagsCustomMailFacturaVinculada: [],
      tagsCustomMailAvisoAutofactura: [],
      tagsCustomMailEnviarAutofactura: [],
      tagsCustomMailFinWizard: [],


      maxSizefile: 1048576, // Bytes (1MB)
      fileLight: {
        name: '',
        b64: '',
        bytes: null,
      },
      fileDark: {
        name: '',
        b64: '',
        bytes: null,
      },
      checkall: false,
      valuesCheckbox: {
        fileLight: false,
        fileDark: false,

        color: false,

        Smtp: false,
        // smptConfirmacionEntrega: false,

        asuntoMailNuevoUsuario: false,
        asuntoMailRecuperacionPass: false,
        asuntoMailDobleAuth: false,
        asuntoMailEnviosMasivos: false,
        asuntoMailEnviarFactura: false,
        asuntoMailOtrosAvisos: false,
        asuntoMailNuevaFacturaEmitida: false,
        asuntoMailNuevaFacturaRecibida: false,
        asuntoMailCambioEstadoFactura: false,
        asuntoMailFacturaVinculada: false,
        asuntoMailAvisoAutofactura: false,
        asuntoMailEnviarAutofactura: false,
        asuntoMailFinWizard: false,
        

        contentTextEditorDefaultOtrosAvisos: false,
        contentTextEditorDefaultNuevaFacturaEmitida: false,
        contentTextEditorDefaultNuevaFacturaRecibida: false,
        contentTextEditorDefaultCambioEstadoFactura: false,
        contentTextEditorDefaultFacturaVinculada: false,
        contentTextEditorDefaultAvisoAutofactura: false,
        contentTextEditorDefaultEnviarAutofactura: false,
        contentTextEditorDefaultEnviarFactura: false,
        contentTextEditorDefaultNuevoUsuario: false,
        contentTextEditorDefaultRecuperacionPass: false,
        contentTextEditorDefaultDobleAuth: false,
        contentTextEditorDefaultEnviosMasivos: false,
        contentTextEditorDefaultFinWizard: false,

      },
      rules: {
        fileLight: [
          {
            message: i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.png', '.webp'], true) }),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileLight.name && 
                (this.fileLight.name.length < 5 || 
                (this.getExtensionFromFile(this.fileLight.name).toUpperCase() !== 'PNG' && 
                this.getExtensionFromFile(this.fileLight.name).toUpperCase() !== 'WEBP'))
              ) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.png', '.webp'], true) })))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.logo_width_height'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileLight.name &&
                (this.$refs['logo-custom-client-light'].naturalHeight !== 74 || this.$refs['logo-custom-client-light'].naturalWidth !== 300)) {
                callback(new Error(i18n.t('validation.logo_width_height')))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.exceed_size_files') + ' (1 MB)',
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileLight.name && this.fileLight.bytes && 
                this.fileLight.bytes.size > this.maxSizeFile) {
                callback(new Error(i18n.t('validation.exceed_size_files')))
              } else {
                callback()
              }
            }
          },
        ],
        fileDark: [
          {
            message: i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.png', '.webp'], true) }),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileDark.name && 
                (this.fileDark.name.length < 5 || 
                (this.getExtensionFromFile(this.fileDark.name).toUpperCase() !== 'PNG' && 
                this.getExtensionFromFile(this.fileDark.name).toUpperCase() !== 'WEBP'))
              ) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.png', '.webp'], true) })))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.logo_width_height'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileDark.name &&
                (this.$refs['logo-custom-client-dark'].naturalHeight !== 74 || this.$refs['logo-custom-client-dark'].naturalWidth !== 300)) {
                callback(new Error(i18n.t('validation.logo_width_height')))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.exceed_size_files') + ' (1 MB)',
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileDark.name && this.fileDark.bytes &&
                this.fileDark.bytes.size > this.maxSizeFile) {
                callback(new Error(i18n.t('validation.exceed_size_files')))
              } else {
                callback()
              }
            }
          },
        ],
        smtpServer: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        smtpFrom: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        smtpPort: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        smptClientId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        smptTenantId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        smtpUser: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        smtpPass: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    gettextEditorCustomMailNuevoUsuario () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailNuevoUsuario.getContent()
    },
    gettextEditorCustomMailRecuperacionPass () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailRecuperacionPass.getContent()
    },
    gettextEditorCustomMailDobleAuth () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailDobleAuth.getContent()
    },
    gettextEditorCustomMailEnviosMasivos () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailEnviosMasivos.getContent()
    },
    gettextEditorCustomMailEnviarFactura () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailEnviarFactura.getContent()
    },
    gettextEditorCustomMailOtrosAvisos () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailOtrosAvisos.getContent()
    },
    gettextEditorCustomMailNuevaFacturaEmitida () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailNuevaFacturaEmitida.getContent()
    },
    gettextEditorCustomMailNuevaFacturaRecibida () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailNuevaFacturaRecibida.getContent()
    },
    gettextEditorCustomMailCambioEstadoFactura () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailCambioEstadoFactura.getContent()
    },
    gettextEditorCustomMailFacturaVinculada () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailFacturaVinculada.getContent()
    },
    gettextEditorCustomMailAvisoAutofactura () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailAvisoAutofactura.getContent()
    },
    gettextEditorCustomMailEnviarAutofactura () {
      if (!this.isMounted) return
      return this.$refs.textEditorCustomMailEnviarAutofactura.getContent()
    },
    gettextEditorCustomMailFinWizard () { 
      if (!this.isMounted || !this.form?.asuntoMailFinWizard) return
      return this.$refs.textEditorCustomMailFinWizard.getContent()
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    titleLinkClients () {
      return this.modeTemplate ? i18n.t('configurations.link_template_to_entity', { entity: this.entity }) : i18n.t('configurations.apply_selected_to_entity', { entity: this.entity })
    },
    id () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : -1
    },
    isFromClient () {
      return this.id !== -1
    },
    hasModuleCustomSMTPCliente () {
      return this.$store.getters['auth/hasCustomSMTPClienteModule']
    },
    hasModuleCustomLogo () {
      return this.$store.getters['auth/hasCustomLogoModule']
    },
    hasModuleCustomColors () {
      return this.$store.getters['auth/hasCustomColorsModule']
    },
    hasModuleCustomMails () {
      return this.$store.getters['auth/hasCustomMailsModule']
    },
    hasLogoLightSaved () {
      return this.fileLight && this.fileLight.b64 && !this.fileLight.bytes
    },
    hasLogoDarkSaved () {
      return this.fileDark && this.fileDark.b64 && !this.fileDark.bytes
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    colorSelected: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    fileLight: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    fileDark: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    valuesCheckbox: {
      deep: true,
      immediate: true,
      handler: 'watchValuesCheckboxHandler'
    },
    gettextEditorCustomMailNuevoUsuario: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailRecuperacionPass: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailDobleAuth: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailEnviosMasivos: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailEnviarFactura: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailOtrosAvisos: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailNuevaFacturaEmitida: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailNuevaFacturaRecibida: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailCambioEstadoFactura: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailFacturaVinculada: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailAvisoAutofactura: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailEnviarAutofactura: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler',
    },
    gettextEditorCustomMailFinWizard: { 
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    modeTemplate: function (value, oldValue) {
      if (!value) this.header.title = i18n.t('configurations.template_header_text_mode')
      else this.header.title = i18n.t('configurations.template_header_text')
    },
  },
  created: async function () {
    const breadcrumbs = []
    if (this.isFromClient) {
      breadcrumbs.push({
        path: 'configurationssa',
        name: i18n.t('configurations.header')
      })
      breadcrumbs.push({
        path: 'configurations/distributors',
        name: i18n.t('distributors.header')
      })
      const distributor = await this.downloadDistributorData(this.id)
      breadcrumbs.push({ path: '', name: distributor.distribuidor.Nombre })
      this.$store.commit('app/setheaderBreadCrumb', distributor.distribuidor.Nombre)
      this.disableRoutes(distributor.distribuidor.idTipoProvisionamiento)
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted: async function () {
    this.isMounted = true
    if (this.$route.params.data) {
      this.preSelectClients()
    } else {
      this.$store.commit('setIsLoading', true)
      const dataLogo = await this.downloadDataLogo(this.id)
      this.setDataLogo(dataLogo)
      const dataColors = await this.downloadDataColors(this.id)
      this.setDataColors(dataColors)
      const dataSmtp = await this.downloadDataSmtp(this.id)
      this.setDataSmtp(dataSmtp.ConfigSMTP)
      const dataCorreos = await this.downloadDataCorreos(this.id)
      this.setDataCorreos(dataCorreos.Plantillas)
      const dataCorreosTags = await this.downloadDataCorreosTags(this.id)
      this.setDataCorreosTags(dataCorreosTags.Tags)
      this.$store.commit('setIsLoading', false)
    }
    // this.resetControlFormChanges()
  },
  methods: {
    editSmtpPassToggle () {
      if (this.disableEditPass) this.form.smtpPass = ''
      else this.form.smtpPass = '**********'
      this.disableEditPass = !this.disableEditPass
    },
    disableRoutes: function (idTipoProvisionamiento) {
      const objDisableRoutes = {
        disableModules: idTipoProvisionamiento === 1,
        disableLocations: idTipoProvisionamiento === 1,
      }
      bus.$emit('disableOptionsDistributor', objDisableRoutes)
    },
    handleChangeLight: function (fileLight) {
      this.$refs.uploadlogo.clearValidate()
      this.fileLight.name = fileLight.name
      this.getBase64(fileLight.raw).then(res => {
        const b64 = res.split(',')
        this.fileLight.b64 = b64[1]
      })
      this.fileLight.bytes = fileLight
    },
    handleChangeDark: function (fileDark) {
      this.$refs.uploadlogo.clearValidate()
      this.fileDark.name = fileDark.name
      this.getBase64(fileDark.raw).then(res => {
        const b64 = res.split(',')
        this.fileDark.b64 = b64[1]
      })
      this.fileDark.bytes = fileDark
    },
    handleRemoveLight: function () {
      this.fileLight.name = null
      this.fileLight.b64 = null
      this.fileLight.bytes = null
    },
    handleRemoveDark: function () {
      this.fileDark.name = null
      this.fileDark.b64 = null
      this.fileDark.bytes = null
    },
    isNumberValid: function (rule, value, callback) {
      if (!value || value === '') {
        return callback(new Error(i18n.t('validation.complete')))
        // callback()
      } else if (!isValidNum(value)) {
        callback(new Error(i18n.t('validation.num_max_custom', { max: 4 })))
      } else {
        callback()
      }
    },
    preSelectClients () {
      this.enableEditCampos = false
      this.modeTemplate = false
      this.visibleEditPass = false
      this.disableEditPass = false
      const data = this.$route.params.data
      if (data && data.clients) {
        this.$refs.templatelinkcompaniesdialog.changeSelectedCompanies(data.clients)
      }
      this.togglePopoverRedirection()
    },
    togglePopoverRedirection: async function () {
      this.showPopoverRedirection = true
      setTimeout(() => {
        this.showPopoverRedirection = false
      }, 3000)
    },
    watchValuesCheckboxHandler: function () {
      const aux = this.valuesCheckbox
      const checkboxKeys = Object.keys(aux)
      this.checkall = true
      checkboxKeys.forEach(key => {
        if (!aux[key]) {
          this.checkall = false
          return false
        }
      })
    },
    toggleModeTemplate: function () {
      this.modeTemplate = !this.modeTemplate
      if (!this.modeTemplate) {
        this.disableEditPass = false
        this.form.smtpPass = ''
      }
    },
    changeAllCheckbox (value) {
      this.valuesCheckbox.fileLight = value
      this.valuesCheckbox.fileDark = value
      this.valuesCheckbox.color = value
      this.valuesCheckbox.Smtp = value
      this.valuesCheckbox.asuntoMailNuevoUsuario = value
      this.valuesCheckbox.asuntoMailRecuperacionPass = value
      this.valuesCheckbox.asuntoMailDobleAuth = value
      this.valuesCheckbox.asuntoMailEnviosMasivos = value
      this.valuesCheckbox.asuntoMailEnviarFactura = value
      this.valuesCheckbox.asuntoMailOtrosAvisos = value
      this.valuesCheckbox.asuntoMailNuevaFacturaEmitida = value
      this.valuesCheckbox.asuntoMailNuevaFacturaRecibida = value
      this.valuesCheckbox.asuntoMailCambioEstadoFactura = value
      this.valuesCheckbox.asuntoMailFacturaVinculada = value
      this.valuesCheckbox.asuntoMailAvisoAutofactura = value
      // this.valuesCheckbox.asuntoMailFinWizard = value
      this.valuesCheckbox.contentTextEditorDefaultOtrosAvisos = value
      this.valuesCheckbox.contentTextEditorDefaultNuevaFacturaEmitida = value
      this.valuesCheckbox.contentTextEditorDefaultNuevaFacturaRecibida = value
      this.valuesCheckbox.contentTextEditorDefaultCambioEstadoFactura = value
      this.valuesCheckbox.contentTextEditorDefaultFacturaVinculada = value
      this.valuesCheckbox.contentTextEditorDefaultAvisoAutofactura = value
      this.valuesCheckbox.contentTextEditorDefaultNuevoUsuario = value
      this.valuesCheckbox.contentTextEditorDefaultRecuperacionPass = value
      this.valuesCheckbox.contentTextEditorDefaultDobleAuth = value
      this.valuesCheckbox.contentTextEditorDefaultEnviosMasivos = value
      this.valuesCheckbox.contentTextEditorDefaultEnviarFactura = value
      // this.valuesCheckbox.contentTextEditorDefaultFinWizard = value 
    },
    toggleDialogLink: function () {
      this.linkToClientsDialog = !this.linkToClientsDialog
    },
    applyLinkHandler: async function (clients) {
      if (this.modeTemplate) {
        this.submitFormAndUpdateClients('ruleForm', clients)
      } else {
        this.UpdateClientsWithSelected('ruleForm', clients)
      }
    },
    downloadDistributorData: async function (id) {
      let distributor = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idDistribuidor: id
        }
        distributor = await getDistributor(params)
        if (distributor.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', distributor))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return distributor
    },
    watchFormHandler () {
      // this.$store.commit('app/setFormChanges', true)
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    cleanSmtpForm () {
      this.form.smtpMain = false
      this.form.smtpServer = null
      this.form.smtpFrom = null
      this.form.smtpPort = null
      this.form.smptSSL = true
      this.form.smptOAuth2 = null
      this.form.smptClientId = null
      this.form.smptTenantId = null
      this.form.smtpUser = null
      this.form.smtpPass = null
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = {
            idDistribuidor: this.id,
            Logo: this.hasModuleCustomLogo && this.fileLight && this.fileLight.b64 && this.fileLight.name
              ? {
                Contenido: this.fileLight.b64,
                Extension: this.getExtensionFromFile(this.fileLight.name)
              } 
              : null,
            LogoDark: this.hasModuleCustomLogo && this.fileDark && this.fileDark.b64 && this.fileDark.name
              ? {
                Contenido: this.fileDark.b64,
                Extension: this.getExtensionFromFile(this.fileDark.name)
              }
              : null,
            Color: this.hasModuleCustomColors ? this.colorSelected : null,
            ConfigSMTP: this.hasModuleCustomSMTPCliente && this.form.smtpMain 
              ? {
                Servidor: this.form.smtpServer,
                UsrDefecto: this.form.smtpFrom,
                Puerto: this.form.smtpPort,
                SSL: this.form.smptSSL,
                OAuth2: this.form.smptOAuth2,
                ClientId: this.form.smptOAuth2 ? this.form.smptClientId : null,
                TenantId: this.form.smptOAuth2 ? this.form.smptTenantId : null,
                Usuario: this.form.smtpUser,
                Password: this.disableEditPass ? null : this.form.smtpPass,
              }
              : null,
            PlantillasCorreos: this.hasModuleCustomMails 
              ? {
                AsuntoUsuarioNuevo: this.form.asuntoMailNuevoUsuario,
                AsuntoRecuperacionPassword: this.form.asuntoMailRecuperacionPass,
                AsuntoDobleAuth: this.form.asuntoMailDobleAuth,
                AsuntoEnviosMasivos: this.form.asuntoMailEnviosMasivos,
                AsuntoEnviarFactura: this.form.asuntoMailEnviarFactura,
                AsuntoAvisoOtros: this.form.asuntoMailOtrosAvisos,
                AsuntoNuevaFacturaEmitida: this.form.asuntoMailNuevaFacturaEmitida,
                AsuntoNuevaFacturaRecibida: this.form.asuntoMailNuevaFacturaRecibida,
                AsuntoCambioEstadoFactura: this.form.asuntoMailCambioEstadoFactura,
                AsuntoFacturaVinculada: this.form.asuntoMailFacturaVinculada,
                AsuntoAvisoAutofactura: this.form.asuntoMailAvisoAutofactura,
                AsuntoEnviarAutofactura: this.form.asuntoMailEnviarAutofactura,
                AsuntoFinWizard: this.form.asuntoMailFinWizard,
                CuerpoUsuarioNuevo: this.$refs.textEditorCustomMailNuevoUsuario.getContent(),
                CuerpoRecuperacionPassword: this.$refs.textEditorCustomMailRecuperacionPass.getContent(),
                CuerpoDobleAuth: this.$refs.textEditorCustomMailDobleAuth.getContent(),
                CuerpoEnviosMasivos: this.$refs.textEditorCustomMailEnviosMasivos.getContent(),
                CuerpoEnviarFactura: this.$refs.textEditorCustomMailEnviarFactura.getContent(),
                CuerpoAvisoOtros: this.$refs.textEditorCustomMailOtrosAvisos.getContent(),
                CuerpoNuevaFacturaEmitida: this.$refs.textEditorCustomMailNuevaFacturaEmitida.getContent(),
                CuerpoNuevaFacturaRecibida: this.$refs.textEditorCustomMailNuevaFacturaRecibida.getContent(),
                CuerpoCambioEstadoFactura: this.$refs.textEditorCustomMailCambioEstadoFactura.getContent(),
                CuerpoFacturaVinculada: this.$refs.textEditorCustomMailFacturaVinculada.getContent(),
                CuerpoAvisoAutofactura: this.$refs.textEditorCustomMailAvisoAutofactura.getContent(),
                CuerpoEnviarAutofactura: this.$refs.textEditorCustomMailEnviarAutofactura.getContent(),
                CuerpoFinWizard: this.form.asuntoMailFinWizard ? this.$refs.textEditorCustomMailFinWizard.getContent() : null,
              } 
              : null,
          }
          const response = await updateClientPersonalizacionTemplate({ idDistribuidor: this.id }, payload)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_template_msg'), 'success')
            if (this.hasModuleCustomSMTPCliente && this.form.smtpMain) {
              this.form.smtpPass = '**********'
              this.visibleEditPass = true
              this.disableEditPass = true
            }
            if (!this.form.smtpMain) {
              this.cleanSmtpForm()
              this.visibleEditPass = false
              this.disableEditPass = false
            }
            await this.$store.dispatch('app/getColors')
            await this.$store.dispatch('app/updateFrontColors')
            // this.resetControlFormChanges()
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    submitFormAndUpdateClients: function (formName, clients) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            idDistribuidor: this.id,
            Logo: this.hasModuleCustomLogo && this.fileLight && this.fileLight.b64 && this.fileLight.name
              ? {
                Contenido: this.fileLight.b64,
                Extension: this.getExtensionFromFile(this.fileLight.name)
              } 
              : null,
            LogoDark: this.hasModuleCustomLogo && this.fileDark && this.fileDark.b64 && this.fileDark.name
              ? {
                Contenido: this.fileDark.b64,
                Extension: this.getExtensionFromFile(this.fileDark.name)
              }
              : null,
            Color: this.hasModuleCustomColors ? this.colorSelected : null,
            ConfigSMTP: this.hasModuleCustomSMTPCliente && this.form.smtpMain 
              ? {
                Servidor: this.form.smtpServer,
                UsrDefecto: this.form.smtpFrom,
                Puerto: this.form.smtpPort,
                SSL: this.form.smptSSL,
                OAuth2: this.form.smptOAuth2,
                ClientId: this.form.smptClientId,
                TenantId: this.form.smptTenantId,
                Usuario: this.form.smtpUser,
                Password: this.disableEditPass ? null : this.form.smtpPass,
              }
              : null,
            PlantillasCorreos: this.hasModuleCustomMails 
              ? {
                AsuntoUsuarioNuevo: this.form.asuntoMailNuevoUsuario,
                AsuntoRecuperacionPassword: this.form.asuntoMailRecuperacionPass,
                AsuntoDobleAuth: this.form.asuntoMailDobleAuth,
                AsuntoEnviosMasivos: this.form.asuntoMailEnviosMasivos,
                AsuntoEnviarFactura: this.form.asuntoMailEnviarFactura,
                AsuntoAvisoOtros: this.form.asuntoMailOtrosAvisos,
                AsuntoNuevaFacturaEmitida: this.form.asuntoMailNuevaFacturaEmitida,
                AsuntoNuevaFacturaRecibida: this.form.asuntoMailNuevaFacturaRecibida,
                AsuntoCambioEstadoFactura: this.form.asuntoMailCambioEstadoFactura,
                AsuntoFacturaVinculada: this.form.asuntoMailFacturaVinculada,
                AsuntoAvisoAutofactura: this.form.asuntoMailAvisoAutofactura,
                AsuntoEnviarAutofactura: this.form.asuntoMailEnviarAutofactura,
                AsuntoFinWizard: this.form.asuntoMailFinWizard,
                CuerpoUsuarioNuevo: this.gettextEditorCustomMailNuevoUsuario,
                CuerpoRecuperacionPassword: this.gettextEditorCustomMailRecuperacionPass,
                CuerpoDobleAuth: this.gettextEditorCustomMailDobleAuth,
                CuerpoEnviarFactura: this.gettextEditorCustomMailEnviarFactura,
                CuerpoEnviosMasivos: this.gettextEditorCustomMailEnviosMasivos,
                CuerpoAvisoOtros: this.gettextEditorCustomMailOtrosAvisos,
                CuerpoNuevaFacturaEmitida: this.gettextEditorCustomMailNuevaFacturaEmitida,
                CuerpoNuevaFacturaRecibida: this.gettextEditorCustomMailNuevaFacturaRecibida,
                CuerpoCambioEstadoFactura: this.gettextEditorCustomMailCambioEstadoFactura,
                CuerpoFacturaVinculada: this.gettextEditorCustomMailFacturaVinculada,
                CuerpoAvisoAutofactura: this.gettextEditorCustomMailAvisoAutofactura,
                CuerpoEnviarAutofactura: this.gettextEditorCustomMailEnviarAutofactura,
                CuerpoFinWizard: this.gettextEditorCustomMailFinWizard,
              } 
              : null,
          }
          this.toggleDialogLink()
          const response = await updateClientPersonalizacionTemplate({ idDistribuidor: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_template_msg'), 'success')
            if (this.hasModuleCustomSMTPCliente && this.form.smtpMain) {
              this.form.smtpPass = '**********'
              this.visibleEditPass = true
              this.disableEditPass = true
            }
            if (!this.form.smtpMain) {
              this.cleanSmtpForm()
              this.visibleEditPass = false
              this.disableEditPass = false
            }
            await this.$store.dispatch('app/getColors')
            await this.$store.dispatch('app/updateFrontColors')
            // this.resetControlFormChanges()
            const response = await applyClientPersonalizationTemplate({ idDistribuidor: this.id }, clients)
            if (response.blnError === true) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
            } else {
              this.doFeedback(i18n.t('feedback.success.updated_clients_msg'), 'success')
              // this.resetControlFormChanges()
            }
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    UpdateClientsWithSelected: function (formName, clients) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            idDistribuidor: this.id,
            idClientes: clients,

            checkLogo: this.valuesCheckbox.fileLight,
            checkColor: this.valuesCheckbox.color,
            checkLogoDark: this.valuesCheckbox.fileDark,
            checkConfigSMTP: this.valuesCheckbox.Smtp,

            Logo: this.hasModuleCustomLogo && this.fileLight && this.fileLight.b64 && this.fileLight.name
              ? {
                Contenido: this.fileLight.b64,
                Extension: this.getExtensionFromFile(this.fileLight.name)
              } 
              : null,
            LogoDark: this.hasModuleCustomLogo && this.fileDark && this.fileDark.b64 && this.fileDark.name
              ? {
                Contenido: this.fileDark.b64,
                Extension: this.getExtensionFromFile(this.fileDark.name)
              }
              : null,
            Color: this.hasModuleCustomColors ? this.colorSelected : null,
            ConfigSMTP: this.hasModuleCustomSMTPCliente && this.form.smtpMain 
              ? {
                Servidor: this.form.smtpServer,
                UsrDefecto: this.form.smtpFrom,
                Puerto: this.form.smtpPort,
                SSL: this.form.smptSSL,
                OAuth2: this.form.smptOAuth2,
                ClientId: this.form.smptClientId,
                TenantId: this.form.smptTenantId,
                Usuario: this.form.smtpUser,
                Password: this.form.smtpPass,
              }
              : null,
            PlantillasCorreos: this.hasModuleCustomMails 
              ? {
                AsuntoUsuarioNuevo: this.form.asuntoMailNuevoUsuario,
                AsuntoRecuperacionPassword: this.form.asuntoMailRecuperacionPass,
                AsuntoDobleAuth: this.form.asuntoMailDobleAuth,
                AsuntoEnviosMasivos: this.form.asuntoMailEnviosMasivos,
                AsuntoEnviarFactura: this.form.asuntoMailEnviarFactura,
                AsuntoAvisoOtros: this.form.asuntoMailOtrosAvisos,
                AsuntoNuevaFacturaEmitida: this.form.asuntoMailNuevaFacturaEmitida,
                AsuntoNuevaFacturaRecibida: this.form.asuntoMailNuevaFacturaRecibida,
                AsuntoCambioEstadoFactura: this.form.asuntoMailCambioEstadoFactura,
                AsuntoFacturaVinculada: this.form.asuntoMailFacturaVinculada,
                AsuntoAvisoAutofactura: this.form.asuntoMailAvisoAutofactura,
                AsuntoEnviarAutofactura: this.form.asuntoMailEnviarAutofactura,
                AsuntoFinWizard: this.form.asuntoMailFinWizard,
                CuerpoUsuarioNuevo: this.gettextEditorCustomMailNuevoUsuario,
                CuerpoRecuperacionPassword: this.gettextEditorCustomMailRecuperacionPass,
                CuerpoDobleAuth: this.gettextEditorCustomMailDobleAuth,
                CuerpoEnviosMasivos: this.gettextEditorCustomMailEnviosMasivos,
                CuerpoEnviarFactura: this.gettextEditorCustomMailEnviarFactura,
                CuerpoAvisoOtros: this.gettextEditorCustomMailOtrosAvisos,
                CuerpoNuevaFacturaEmitida: this.gettextEditorCustomMailNuevaFacturaEmitida,
                CuerpoNuevaFacturaRecibida: this.gettextEditorCustomMailNuevaFacturaRecibida,
                CuerpoCambioEstadoFactura: this.gettextEditorCustomMailCambioEstadoFactura,
                CuerpoFacturaVinculada: this.gettextEditorCustomMailFacturaVinculada,
                CuerpoAvisoAutofactura: this.gettextEditorCustomMailAvisoAutofactura,
                CuerpoEnviarAutofactura: this.gettextEditorCustomMailEnviarAutofactura,
                CuerpoFinWizard: this.gettextEditorCustomMailFinWizard,

                checkAsuntoUsuarioNuevo: this.valuesCheckbox.asuntoMailNuevoUsuario,
                checkAsuntoRecuperacionPassword: this.valuesCheckbox.asuntoMailRecuperacionPass,
                checkAsuntoDobleAuth: this.valuesCheckbox.asuntoMailDobleAuth,
                checkAsuntoEnviosMasivos: this.valuesCheckbox.asuntoMailEnviosMasivos,
                checkAsuntoEnviarFactura: this.valuesCheckbox.asuntoMailEnviarFactura,
                checkAsuntoAvisoOtros: this.valuesCheckbox.asuntoMailOtrosAvisos,
                checkAsuntoNuevaFacturaEmitida: this.valuesCheckbox.asuntoMailNuevaFacturaEmitida,
                checkAsuntoNuevaFacturaRecibida: this.valuesCheckbox.asuntoMailNuevaFacturaRecibida,
                checkAsuntoCambioEstadoFactura: this.valuesCheckbox.asuntoMailCambioEstadoFactura,
                checkAsuntoFacturaVinculada: this.valuesCheckbox.asuntoMailFacturaVinculada,
                checkAsuntoAvisoAutofactura: this.valuesCheckbox.asuntoMailAvisoAutofactura,
                checkAsuntoEnviarAutofactura: this.valuesCheckbox.asuntoMailEnviarAutofactura,
                // checkAsuntoFinWizard: this.valuesCheckbox.asuntoMailFinWizard, 
                checkCuerpoUsuarioNuevo: this.valuesCheckbox.contentTextEditorDefaultNuevoUsuario,
                checkCuerpoRecuperacionPassword: this.valuesCheckbox.contentTextEditorDefaultRecuperacionPass,
                checkCuerpoDobleAuth: this.valuesCheckbox.contentTextEditorDefaultDobleAuth,
                checkCuerpoEnviosMasivos: this.valuesCheckbox.contentTextEditorDefaultEnviosMasivos,
                checkCuerpoEnviarFactura: this.valuesCheckbox.contentTextEditorDefaultEnviarFactura,
                checkCuerpoAvisoOtros: this.valuesCheckbox.contentTextEditorDefaultOtrosAvisos,
                checkCuerpoNuevaFacturaEmitida: this.valuesCheckbox.contentTextEditorDefaultNuevaFacturaEmitida,
                checkCuerpoNuevaFacturaRecibida: this.valuesCheckbox.contentTextEditorDefaultNuevaFacturaRecibida,
                checkCuerpoCambioEstadoFactura: this.valuesCheckbox.contentTextEditorDefaultCambioEstadoFactura,
                checkCuerpoFacturaVinculada: this.valuesCheckbox.contentTextEditorDefaultFacturaVinculada,
                checkCuerpoAvisoAutofactura: this.valuesCheckbox.contentTextEditorDefaultAvisoAutofactura,
                checkCuerpoEnviarAutofactura: this.valuesCheckbox.contentTextEditorDefaultEnviarAutofactura,
                // checkCuerpoFinWizard: this.valuesCheckbox.contentTextEditorDefaultFinWizard, 
              } 
              : null,
          }
          this.toggleDialogLink()
          const response = await applyClientPersonalizationKeys({ idDistribuidor: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.updated_clients_msg'), 'success')
            // if (this.enableEditCampos) {
            //   if (this.hasModuleCustomSMTPCliente && this.form.smtpMain) {
            //     this.form.smtpPass = '**********'
            //     this.visibleEditPass = true
            //     this.disableEditPass = true
            //   }
            //   if (!this.form.smtpMain) {
            //     this.cleanSmtpForm()
            //     this.visibleEditPass = false
            //     this.disableEditPass = false
            //   }
            // }
            // this.resetControlFormChanges()
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (this.isFromClient) this.$router.push({ name: 'configurations/distributors/details', params: this.id })
      else this.$router.push({ name: 'configurations/clients' })
    },
    downloadDataLogo: async function (id) {
      try {
        const template = await getLogoCustomTemplate({ idDistribuidor: this.id })
        if (template.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', template))
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    downloadDataColors: async function () {
      try {
        const response = await getColorsCustomTemplate({ idDistribuidor: this.id })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          return response
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    downloadDataSmtp: async function (id) {
      try {
        const template = await getConfigSMTPTemplate({ idDistribuidor: this.id })
        if (template.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', template))
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    downloadDataCorreos: async function (id) {
      try {
        const template = await getConfigCorreosTemplate({ idDistribuidor: this.id })
        if (template.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', template))
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    downloadDataCorreosTags: async function (id) {
      try {
        const template = await getConfigCorreosTags({ idCliente: this.id })
        if (template.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', template))
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    setDataLogo: function (data) {
      if (data) {
        this.fileLight.b64 = data.Logo?.Contenido 
        this.fileLight.name = data.Logo 
          ? 'logo-claro.' + data.Logo?.Extension 
          : null
        this.fileDark.b64 = data.LogoDark?.Contenido
        this.fileDark.name = data.LogoDark
          ? 'logo-oscuro.' + data.LogoDark?.Extension
          : null
      }
      // this.resetControlFormChanges()
    },
    setDataColors (data) {
      if (data) {
        this.colorSelected = data.Color
      }
      // this.resetControlFormChanges()
    },
    setDataSmtp: function (data) {
      if (data) {
        this.form.smtpMain = true
        this.form.smtpServer = data.Servidor
        this.form.smtpFrom = data.UsrDefecto
        this.form.smtpPort = data.Puerto
        this.form.smptSSL = data.SSL
        this.form.smptClientId = data.ClientId
        this.form.smptTenantId = data.TenantId
        this.form.smtpUser = data.Usuario
        this.form.smtpPass = '**********'
        this.form.smptOAuth2 = !(!data.ClientId && !data.TenantId)
      } else {
        this.form.smtpMain = false
        this.visibleEditPass = false
        this.disableEditPass = false
      }
      // this.resetControlFormChanges()
    },
    setDataCorreos: function (data) {
      if (data) {
        this.form.asuntoMailNuevoUsuario = data.AsuntoUsuarioNuevo
        this.form.asuntoMailRecuperacionPass = data.AsuntoRecuperacionPassword
        this.form.asuntoMailDobleAuth = data.AsuntoDobleAuth
        this.form.asuntoMailEnviosMasivos = data.AsuntoEnviosMasivos
        this.form.asuntoMailEnviarFactura = data.AsuntoEnviarFactura
        this.form.asuntoMailOtrosAvisos = data.AsuntoAvisoOtros
        this.form.asuntoMailNuevaFacturaEmitida = data.AsuntoNuevaFacturaEmitida
        this.form.asuntoMailNuevaFacturaRecibida = data.AsuntoNuevaFacturaRecibida
        this.form.asuntoMailCambioEstadoFactura = data.AsuntoCambioEstadoFactura
        this.form.asuntoMailFacturaVinculada = data.AsuntoFacturaVinculada
        this.form.asuntoMailAvisoAutofactura = data.AsuntoAvisoAutofactura
        this.form.asuntoMailEnviarAutofactura = data.AsuntoEnviarAutofactura
        this.form.asuntoMailFinWizard = data.AsuntoFinWizard
          
        // Contenido
        this.contentTextEditorDefaultNuevoUsuario = data.CuerpoUsuarioNuevo
        this.contentTextEditorDefaultRecuperacionPass = data.CuerpoRecuperacionPassword
        this.contentTextEditorDefaultDobleAuth = data.CuerpoDobleAuth
        this.contentTextEditorDefaultEnviosMasivos = data.CuerpoEnviosMasivos
        this.contentTextEditorDefaultEnviarFactura = data.CuerpoEnviarFactura
        this.contentTextEditorDefaultOtrosAvisos = data.CuerpoAvisoOtros
        this.contentTextEditorDefaultNuevaFacturaEmitida = data.CuerpoNuevaFacturaEmitida
        this.contentTextEditorDefaultNuevaFacturaRecibida = data.CuerpoNuevaFacturaRecibida
        this.contentTextEditorDefaultCambioEstadoFactura = data.CuerpoCambioEstadoFactura
        this.contentTextEditorDefaultFacturaVinculada = data.CuerpoFacturaVinculada
        this.contentTextEditorDefaultAvisoAutofactura = data.CuerpoAvisoAutofactura
        this.contentTextEditorDefaultEnviarAutofactura = data.CuerpoEnviarAutofactura
        this.contentTextEditorDefaultFinWizard = data.CuerpoFinWizard
      }
      // this.resetControlFormChanges()
    },
    setDataCorreosTags: function (data) {
      if (data) {
        // Tags
        this.tagsCustomMailNuevoUsuario = data.filter(x => x.Nombre === 'UsuarioNuevo')[0].Tags
        this.tagsCustomMailRecuperacionPass = data.filter(x => x.Nombre === 'RecuperacionPassword')[0].Tags
        this.tagsCustomMailDobleAuth = data.filter(x => x.Nombre === 'DobleAuth')[0].Tags
        this.tagsCustomMailEnviosMasivos = data.filter(x => x.Nombre === 'EnviosMasivos')[0].Tags
        this.tagsCustomMailEnviarFactura = data.filter(x => x.Nombre === 'EnviarFactura')[0].Tags
        this.tagsCustomMailOtrosAvisos = data.filter(x => x.Nombre === 'AvisoOtros')[0].Tags
        this.tagsCustomMailNuevaFacturaEmitida = data.filter(x => x.Nombre === 'NuevaFacturaEmitida')[0].Tags
        this.tagsCustomMailNuevaFacturaRecibida = data.filter(x => x.Nombre === 'NuevaFacturaRecibida')[0].Tags
        this.tagsCustomMailCambioEstadoFactura = data.filter(x => x.Nombre === 'CambioEstadoFactura')[0].Tags
        this.tagsCustomMailFacturaVinculada = data.filter(x => x.Nombre === 'FacturaVinculada')[0].Tags
        this.tagsCustomMailAvisoAutofactura = data.filter(x => x.Nombre === 'AvisoAutofactura')[0].Tags
        this.tagsCustomMailEnviarAutofactura = data.filter(x => x.Nombre === 'EnviarAutofactura')[0].Tags
        this.tagsCustomMailFinWizard = data.filter(x => x.Nombre === 'AvisoFinWizard')[0].Tags 
      }
      // this.resetControlFormChanges()
    }
  }
}
</script>
